<template>
    
    <!-- Encabezado de la aplicación -->
    <div class="appHeader no-border">
        <div class="left">
            <a href="#" class="headerButton goBack">
                <ion-icon name="chevron-back-outline"></ion-icon>
            </a>
        </div>
        <div class="pageTitle">
            Verificación de recarga
        </div>
        <div class="right"> </div>
    </div>
    <!-- * Encabezado de la aplicación -->

    <!-- Cápsula de la aplicación -->
    <div id="appCapsule" v-if="network != null && asset != null">

        <div class="section">
            <div class="splash-page mt-5 mb-5">

                <div class="transfer-verification">
                    <div class="transfer-amount">
                        <span class="caption">Cantidad</span>
                        <h2>{{ amount }} {{ asset.symbol }}</h2>
                    </div>
                    <div class="from-to-block mb-5">
                        <div class="item text-center">
                            <img :src="network.src.network.image" alt="avatar" class="imaged w48">
                            <strong>{{ network.src.network.name }}</strong>
                        </div>
                        <div class="item text-center">
                            <img :src="asset.image" alt="avatar" class="imaged w48">
                            <strong>Sombrero Chain</strong>
                        </div>
                        <div class="arrow"></div>
                    </div>
                </div>
                <h2 class="mb-2 mt-2">Verifique la recarga</h2>
                <p>
                    Está recargando <strong class="text-primary">{{ amount }} {{ asset.symbol }} </strong> desde {{ network.src.network.name }} en {{ asset.name }} ({{ asset.symbol }}).<br>¿Está seguro?
                </p>
            </div>
        </div>

        <div class="fixed-bar">
            <div class="row">
                <div class="col-6">
                    <router-link to="/" class="btn btn-lg btn-outline-secondary btn-block">Cancelar</router-link>
                </div>
                <div class="col-6">
                    <button @click="aproveDeposit" :disabled="sending" class="btn btn-lg btn-primary btn-block">Confirmar</button>
                </div>
            </div>
        </div>

    </div>
    <!-- * Cápsula de la aplicación -->

</template>

<script>
// eslint-disable-next-line
import { ethers } from 'ethers';
import { mapState, mapActions } from 'vuex';
export default {
    data() {
        return {
            sending: false,
        };
    },
    computed: {
        ...mapState(['portfolio']),
        asset() {
            return this.portfolio[this.$route.params.asset_id] ?? null;
        },
        network() {
            return this.networks[this.$route.params.network_id] ?? null;
        },
        networks() {
            return this.portfolio[this.$route.params.asset_id].networks_recharge ?? [];
        },
        amount() {
            return this.network.src.balance;
        },
    },
    methods: {
        ...mapActions(['newNotification', 'v1_verifyDeposit']),
        /* eslint-disable */
        async aproveDeposit() {
            const self = this
            console.log('aproveDeposit')
            this.sending = true;
            self.$swal.fire({
                title: "Verificacion",
                html: `Está recargando <strong class="text-primary">${self.amount} ${self.asset.symbol} </strong> desde ${self.network.src.network.name} en ${self.asset.name} (${self.asset.symbol}).<br>¿Está seguro?`,
                // input: "text",
                inputAttributes: {
                    autocapitalize: "off"
                },
                // showCancelButton: true,
                confirmButtonText: "Si, continuar",
                cancelButtonText: "Cancelar",
                showLoaderOnConfirm: true,
                preConfirm: async (login) => {
                    console.log('preConfirm', login)
                    try {
                        const res = await this.v1_verifyDeposit({
                            network: this.$route.params.network_id,
                            asset: this.$route.params.asset_id,
                        })
                        if (res == true) {
                            let timerInterval;
                            return self.$swal.fire({
                                icon: "success",
                                title: "Recarga Exitosa!",
                                html: "Espere mientras te redireccionamos <b></b> millisegundos.",
                                timer: 5000,
                                timerProgressBar: true,
                                didOpen: () => {
                                    self.$swal.showLoading();
                                    const timer = self.$swal.getPopup().querySelector("b");
                                    timerInterval = setInterval(() => {
                                    timer.textContent = `${self.$swal.getTimerLeft()}`;
                                    }, 100);
                                },
                                willClose: () => {
                                    clearInterval(timerInterval);
                                }
                                }).then((result) => {
                                if (result.dismiss === self.$swal.DismissReason.timer) {
                                    location.replace("/")
                                }
                            });
                        }
                        return false;
                    } catch (error) {
                        console.log('error:preConfirm', error)
                        self.$swal.showValidationMessage(`Error: ${error}`);
                    }
                },
                allowOutsideClick: () => !self.$swal.isLoading()
            }).then(async (result) => {
                self.sending = false;
                if (result.isConfirmed) {
                    setTimeout(()=>{
                        location.replace("/")
                    }, 5000)
                }
            });
        },
    },
    async mounted() {
        this.$root.loadBackButtom();
        
    //     console.log('rpcs', this.network.src.network.rpcs[0] ?? null)
    //     console.log('asset', this.asset)
    //     console.log('asset.address', this.asset.address)
    //     console.log('asset.wallet', this.asset.wallet)
        
    //     if (this.network.src.network.rpcs.length == 0) {
    //         this.newNotification({
    //         type: "danger",
    //         title: "Red no accesible",
    //         message: "No hay nodos de conexion para esta red, contacta con soporte."
    //         })
    //         return false;
    //     }
        
    //     const providerJson = this.network.src.network.rpcs[0];
    //     console.log('providerJson', providerJson)
    //     let provider = null;
    //     provider = new ethers.JsonRpcProvider(`${providerJson}`);

    //     if (provider == null) {
    //         this.newNotification({
    //         type: "danger",
    //         title: "Error Web3",
    //         message: "Error creando la intancia Web3."
    //         })
    //         return false;
    //     }

    //     console.log('provider', provider)
        
    //     // const abi = [{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"}],"name":"balanceOf","outputs":[{"name":"balance","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"payable":true,"stateMutability":"payable","type":"fallback"},{"anonymous":false,"inputs":[{"indexed":true,"name":"owner","type":"address"},{"indexed":true,"name":"spender","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"}];
    //     // const contract = new ethers.Contract(this.asset.address, abi, provider);

    //     // console.log('contract', contract)
        
    //     // // Get token balance as BigNumber
    //     // const balance = await contract.balanceOf(this.asset.wallet);
    //     // const decimals = await contract.decimals();

    //     // // Format the balance for display with 18 decimal places
    //     // const balanceFormatted = ethers.formatUnits(balance, decimals);
    //     // console.log("El saldo del titular es " + balanceFormatted + " " + this.asset.symbol);

    //     // if (balance == 0) {
    //     //     this.newNotification({
    //     //     type: "danger",
    //     //     title: "Error Balance",
    //     //     message: "El saldo del titular es " + balanceFormatted + " " + this.asset.symbol
    //     //     })
    //     //     return false;
    //     // }

    //     // this.amount = balanceFormatted
        
    //     // this.newNotification({
    //     //     type: "info",
    //     //     title: "Balance a recargar",
    //     //     message: "El saldo a recargar es " + balanceFormatted + " " + this.asset.symbol
    //     // })
    },
}
</script>